import jwtDecode from 'jwt-decode';
import msalInstance from './msal';
import { toast } from 'react-toastify';
import Button from '@components/CustomButtons/Button';
import { AccountInfo } from '@azure/msal-browser';

export const isValidAccessToken = (accessToken: string): boolean => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken);
  const currentTime = Date.now();

  return decoded.exp * 1000 > currentTime;
};

export const isValidIdToken = (accountInfo: AccountInfo): boolean => {
  const exp = (accountInfo?.idTokenClaims ? accountInfo?.idTokenClaims['exp'] : 0) * 1000;
  const now = Date.now();
  const isIdTokenValid = exp > now;
  return isIdTokenValid;
}

let logOutTimer: number | null = null;
let ignoreLogoutOnClose: boolean = false;
function clearLogOutTimer() {
  if (logOutTimer) {
    window.clearTimeout(logOutTimer);
  }
}

export const timerLogout = () => {
  clearLogOutTimer();
  logOutTimer = window.setTimeout(() => {
    const message = (
      <div>
        <h5 style={{ marginTop: '5px' }}>Are you still there?</h5>
        <p>If not, You'll be redirected to the sign in page soon</p>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button color='rose' onClick={() => {
            clearLogOutTimer();
            timerLogout();
            ignoreLogoutOnClose = true;
            toast.dismiss();
          }}>I'm here</Button>
          <Button color='default' onClick={() => msalInstance.logoutRedirect()}>Sign out</Button>
        </div>
      </div>
    );

    toast.warning(message, {
      autoClose: 30000,
      icon: false,
      closeButton: false,
      closeOnClick: false,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      onClose: () => {
        if (!ignoreLogoutOnClose) {
          msalInstance.logoutRedirect();
        }
        ignoreLogoutOnClose = false;
      }
    });
  }, 60 * 60 * 3000); // if no active for 3 hours, auto logout! (unit is ms)
}

const getRoles = (accessToken: string): string[] => {
  if (!accessToken) {
    return [];
  }
  const decoded = jwtDecode<{ roles: string[] }>(accessToken);
  return decoded.roles;
};

const crewPayKey = 'crew-pay-accessToken-' + window.location.hostname;

const setCrewPayApiSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem(crewPayKey, accessToken);
    timerLogout();
  } else {
    localStorage.removeItem(crewPayKey);
  }
};

const msGraphKey = 'ms-graph-accessToken-' + window.location.hostname;

const setMsGraphApiSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem(msGraphKey, accessToken);
  } else {
    localStorage.removeItem(msGraphKey);
  }
};

export { getRoles, setCrewPayApiSession, setMsGraphApiSession, crewPayKey, msGraphKey };
